import { randomString } from '@/_utils/string/random-string';
import { OfferTransportKind } from '@/common/enums/OfferTransportKind';
import { QuestionService } from '@/common/question-dialog/question-dialog.service';
import { GroupOfferPriceSettingComponent } from '@/group-offer/group-offer/group-offer-price-setting/group-offer-price-setting.component';
import { AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { DataBagService } from 'src/app/common/data-bag.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { ComponentCanDeactivate } from 'src/app/common/pending-changes.guard';
import { environment } from 'src/environments/environment';
import { ProductRedirectDialogComponent } from './product-redirect-dialog/product-redirect-dialog.component';
import { ProductService } from './product.service';
import { CheckListSelectionPayload, ProductTransitCountryPayload } from './product.model';
import { BagHistoryService } from '@/common/bag-history/bag-history.service';

@Component({
	selector: 'app-product',
	templateUrl: './product.component.html',
	styleUrls: ['./product.component.css'],
})
export class ProductComponent implements OnInit, AfterViewInit, OnDestroy, ComponentCanDeactivate {
	protected api = 'bag';
	protected apiType = 'bag';
	protected apiUrlAdd = '/product/';
	protected apiUrl = '/product/';
	protected parentComponent = 'product';
	editable = false;
	@ViewChild(GroupOfferPriceSettingComponent) priceSettingComponent: any;

	pageTitle = 'Produkty';
	pageFunction = 'edit';
	statusSet: Array<any> = [
		{ value: 'D', name: 'Szkic' },
		{ value: 'P', name: 'Opublikowany' },
		{ value: 'A', name: 'Zarchiwizowany' },
	];

	locations: Array<any> = [];
	currency: Array<any> = [];
	board: Array<any> = [];
	documentKinds: Array<any> = [];
	priceOption: Array<any> = [];
	priceSetting: Array<any> = [];

	readonly OfferTransportKind = OfferTransportKind;

	constructor(
		public service: ProductService,
		private readonly bag: DataBagService,
		protected route: ActivatedRoute,
		private readonly router: Router,
		protected loader: LoaderService,
		protected infobox: InfoboxService,
		private readonly dialog: MatDialog,
		private readonly questionService: QuestionService,
		private readonly bagHistoryService: BagHistoryService,
	) {}

	@HostListener('window:beforeunload') canDeactivate(): Observable<boolean> | boolean {
		return !this.editable;
	}

	copyProduct(): void {
		this.questionService
			.ask('Czy na pewno chcesz skopiować ten produkt? UWAGA - kod produktu zostanie wygenerowany losowo.')
			.subscribe(({ result }) => {
				if (!result) {
					return;
				}

				this.addStop(() => {
					const product = this.dataSendGenerate();
					const randomCode = randomString(6);
					this.bag.post(
						this.apiUrlAdd,
						{
							...product,
							name: `${product.name} - ${randomCode}`,
							code: randomCode,
							descriptions: product.descriptions.map((description) => ({
								...description,
								descriptionHeader: description.descriptionHeader ?? null,
							})),
							productMultimedias: [
								...product.productMultimedias.map((multimedia) => ({ ...multimedia, id: null })),
							],
							rooms: [],
							surchargeProgram: product.surchargeProgram?.description
								? { id: null, description: product.surchargeProgram.description }
								: null,
							priceSetting: null,
							comfortTwinProducts: [],
						},
						(result, error) => {
							this.priceSetting['id'] = null;
							this.service.data.id = result.id;
							this.priceSettingComponent.submit();
							this.afterSend(result, error);
							this.service.data.rooms = [];
							this.service.refreshRooms$.next();
						},
					);
				});
			});
	}

	openWWW(id: number): void {
		const subdomain = environment.production ? '' : 'dev.';
		window.open(`https://${subdomain}oskar.com.pl/oferta/${id}`, '_blank');
	}

	pageTitleGenerate(): string {
		return this.service.data.name + ' (ID: ' + this.service.data.id + ')';
	}

	editUnlock() {
		this.editable = true;
	}

	getStatus(status) {
		return this.statusSet.find((retStatus) => retStatus.value === this.service.data.status).name;
	}

	ngOnInit() {
		if (!this.route.snapshot.params['id']) {
			this.router.navigate([this.parentComponent]);
		}
		if (this.route.snapshot.params['id'] == 'add') {
			this.pageFunction = 'add';
			this.editable = true;
			if (!this.apiUrlAdd) {
				this.apiUrlAdd = '/' + this.parentComponent + '/';
			}
		} else {
			this.pageFunction = 'edit';
			this.service.data.id = this.route.snapshot.params['id'];
			this.apiUrl = '/product/' + this.service.data.id + '/';
		}

		this.bag.get('/currency/?limit=999', (result, error) => {
			this.currency = result.results;
			this.loadData();
		});
		this.bag.get('/board/?limit=999', (result, error) => {
			this.board = result.results;
			this.loadData();
		});
		this.bag.get('/profile/document_kind/?limit=999', (result, error) => {
			this.documentKinds = result.results;
			this.loadData();
		});
		this.bag.get('/offer/price_option/', (result, error) => {
			this.priceOption = result.results;
			this.priceOption.map((obj) => {
				if (obj.method == 'C') {
					obj.method = 'PLN';
				} else obj.method = '%';
			});
			this.loadData();
		});
		this.loadData();
	}

	ngAfterViewInit(): void {
		this.reloadHistory();
	}

	ngOnDestroy(): void {
		this.service.resetData();
	}

	loadData(): void {
		if (this.pageFunction != 'edit') {
			this.loader.hide();
			return;
		}

		this.loader.show();

		this.bag.get(this.apiUrl, (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.service.data = this.convertData(result);
			this.loader.hide();
			this.pageTitle = this.pageTitleGenerate();
			this.service.onChangeProductType.next(true);
			this.service.additionalChargeChange.next(true);
		});

		this.bag.get('/product/convenience/?limit=999', (result, error) => {
			this.service.mockData.convenience = result.results;
		});
	}

	convertData(result) {
		this.service.mockData.code1 = result.code.slice(0, 2);
		this.service.mockData.code2 = result.code.slice(2, 4);
		this.service.mockData.code3 = result.code.slice(4, result.code.length);

		this.service.mockData.mockName = result.name;

		result.conveniences = result.conveniences.map((convenience) => {
			return this.service.mockData.convenience.find((findCon) => findCon.id === convenience);
		});

		if (result.longitude && result.latitude) {
			this.service.mockData.coordinates = `${result.longitude},${result.latitude}`;
		} else {
			this.service.mockData.coordinates = '';
		}

		if (result.surchargeProgram === null) {
			result.surchargeProgram = { id: 1, description: '' };
		}

		if (result.surchargeBoard === null) {
			result.surchargeBoard = {
				fee: 0,
				currency: 1,
			};
		}

		result.rooms = result.rooms.map((room) => {
			room.codeName = room.roomType.code;
			return room;
		});

		result.checkpoints = result.checkpoints.map((checkpoint) =>
			typeof checkpoint === 'object' ? checkpoint.id : checkpoint,
		);

		result.comfortTwinProducts = result.comfortTwinProducts ?? [];

		result.checkpointGroups = result.checkpointGroups.map((group) =>
			typeof group === 'object' ? group.id : group,
		);

		if (this.service.data.priceSetting) {
			this.bag.get('/offer/price_setting/' + this.service.data.priceSetting + '/', (result, error) => {
				this.priceSetting = result;
			});
		}

		this.service.dataLoaded$.next();

		return result;
	}

	reloadHistory(): void {
		if (this.pageFunction === 'add') {
			return;
		}
		this.bagHistoryService.triggerFetchHistory$.next();
	}

	async submit(checkExit) {
		if (!this.service.data.location.length) {
			return this.infobox.error('Uzupełnij pole destynacje!');
		}

		if (!this.priceSettingComponent.validatePriceSettings()) {
			return;
		}

		this.loader.show();
		this.service.checkExit = checkExit;
		switch (this.pageFunction) {
			case 'add':
				this.addStop(() => this.doAdd(this.dataSendGenerate()));
				break;
			case 'edit':
				await this.priceSettingComponent.submit();
				this.doEdit(this.dataSendGenerate());
				break;
		}
	}

	updateProductByCheckList(event: CheckListSelectionPayload): void {
		this.service.data.checkpointGroups = event.checkpointGroups;
		this.service.data.checkpoints = event.checkpoints;
	}

	private addStop(callback: () => void) {
		if (![2, 3].includes(this.service.data.productKind)) {
			callback();
			return;
		}
		const check = this.checkData();
		if (check === false) {
			this.loader.hide();
			return;
		}
		const stopData = {
			location: 3,
			stop_type: 'TG',
			address: this.service.data.name,
			kind: null,
			iataCode: null,
		};
		this.bag.post('/transport/stop/', stopData, (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.service.data.stop = result.id;
			this.service.mockData.stops = [
				...this.service.mockData.stops,
				{
					id: result.id,
					address: result.address,
					location: {
						name: 'Europa',
					},
				},
			];
			callback();
		});
	}

	private checkData() {
		let errorMessage = '';
		if (!this.service.data.name) {
			errorMessage += 'Brak nazwy  <br>';
		}
		if (!this.service.mockData.code1 || !this.service.mockData.code2 || !this.service.mockData.code3) {
			errorMessage += 'Brak kodu <br>';
		}
		if (!this.service.data.board) {
			errorMessage += 'Brak Wyżywienia  <br>';
		}
		if (!this.service.data.organization) {
			errorMessage += 'Brak Organizatora <br>';
		}
		if (!this.service.data.productKind) {
			errorMessage += 'Brak Typu produktu<br>';
		}
		if (errorMessage === '') {
			return true;
		}
		this.infobox.error(errorMessage);
		return false;
	}

	private dataSendGenerate() {
		return {
			id: null,
			insurer: this.service.data.insurer.id,
			insurance: this.service.data.insurance.id,
			productKind: this.service.data.productKind,
			allowedDocuments: this.service.data.allowedDocuments ?? [],
			organization: this.service.data.organization,
			board: this.service.data.board,
			surchargeBoard: this.service.data.surchargeBoard.fee ? this.service.data.surchargeBoard : null,
			stop: this.service.data.stop,
			name: this.service.data.name,
			status: this.pageFunction === 'add' ? 'D' : this.service.data.status,
			code: this.service.mockData.code1 + this.service.mockData.code2 + this.service.mockData.code3,
			zipCode: this.service.data.zipCode,
			address: this.service.data.address,
			buildingNumber: this.service.data.buildingNumber,
			tags: this.service.data.tags,
			location: Array.isArray(this.service.data.location)
				? this.service.data.location
				: [this.service.data.location],
			conveniences: this.service.data.conveniences.map((singleConvenience) => {
				return singleConvenience.id;
			}),
			descriptions: this.service.data.descriptions.map((item) => {
				return {
					descriptionHeader: item.descriptionHeader?.id,
					description: item.description,
					use: item.use,
				};
			}),
			longitude: this.service.mockData.coordinates
				? this.convertCoordinates(this.service.mockData.coordinates, 'longitude')
				: null,
			latitude: this.service.mockData.coordinates
				? this.convertCoordinates(this.service.mockData.coordinates, 'latitude')
				: null,
			surchargeProgram: this.service.data.surchargeProgram.description
				? this.service.data.surchargeProgram
				: null,
			nightsStay: this.service.data.productKind === 3 ? 0 : this.service.data.nightsStay,
			organizationNote: this.service.data.organizationNote ? this.service.data.organizationNote : '',
			productMultimedias: this.service.data.productMultimedias.map((item, index) => {
				return {
					id: item.id,
					multimedia: item.multimedia.id,
					order: index,
				};
			}),
			rooms: this.service.data.rooms.map((room, index) => {
				return {
					id: room.id,
					description: room.description,
					fee: room.fee,
					isActive: room.isActive,
					isNoName: room.isNoName,
					level: room.level,
					order: index,
					roomNumber: room.roomNumber,
					conveniences: room.conveniences,
					roomSlaves: room.roomSlaves.map((roomSlave) => {
						return {
							id: roomSlave.id ?? null,
							roomType: parseInt(roomSlave.roomType.id),
							fee: roomSlave.fee === null ? 0 : roomSlave.fee,
						};
					}),
					roomType: room.roomType.id,
					view: room.view,
				};
			}),
			stars: this.service.data.stars,
			isNightEvent: this.service.data.isNightEvent,
			guides: this.service.data.guides.map((guide) => ({
				...guide,
				destination: guide.destination.id,
				id: null,
			})),
			tickets: this.service.data.tickets.map((ticket) => ({ ...ticket, id: null })),
			hotels: this.service.data.hotels.map((hotel) => ({ ...hotel, id: null })),
			cards: this.service.data.cards.map((card) => ({ ...card, id: null })),
			checkpointGroups: this.service.data.checkpointGroups,
			checkpoints: this.service.data.checkpoints,
			transitCountryFees: (this.service.data.transitCountryFees ?? [])
				.filter((row) => row?.location?.id != null && row.fee != null)
				.map(
					(row): ProductTransitCountryPayload => ({
						id: row.id,
						location: row.location.id,
						fee: row.fee,
					}),
				),
			plannedRouteKilometers: this.service.data.plannedRouteKilometers,
			comfortTwinProducts: this.service.data.comfortTwinProducts ?? [],
		};
	}

	convertCoordinates(coordinates, longLat) {
		if (coordinates.indexOf('null') != -1) {
			return null;
		} else {
			if (longLat === 'longitude') {
				return coordinates.split(',')[0];
			}
			if (longLat === 'latitude') {
				return coordinates.split(',')[1];
			}
		}
	}

	private doAdd(dataSend) {
		this.bag.post(this.apiUrlAdd, dataSend, (result, error) => {
			this.service.data.id = result.id;
			this.priceSettingComponent.submit();
			this.afterSend(result, error);
		});
	}

	private doEdit(dataSend) {
		this.bag.patch(this.apiUrl, dataSend, (result, error) => {
			this.afterSend(result, error);
		});
	}

	private afterSend(result, error) {
		this.loader.hide();
		if (error) {
			let errorMessage = '';
			if (error.error.code) {
				errorMessage += 'Błąd kodu  <br>';
				errorMessage += error.error.code[0] + '</br>';
			}
			if (error.error.stop) {
				errorMessage += 'Błąd przy przystanku  <br>';
				errorMessage += error.error.stop[0] + '</br>';
			}
			if (error.error.location) {
				errorMessage += 'Błąd przy lokalizacji  <br>';
				errorMessage += error.error.location[0] + '</br>';
			}
			if (error.error.name) {
				errorMessage += 'Błąd przy nazwie  <br>';
				errorMessage += error.error.name[0] + '</br>';
			}
			if (errorMessage == '') {
				errorMessage += 'Niezidentyfikowany obiekt błędu, zgłoś się do IT';
			}
			this.infobox.error(errorMessage);
			return;
		}
		const descriptions = this.service.data.descriptions;
		this.service.data = this.convertData(result);
		this.service.data.descriptions = descriptions;
		this.pageFunction = 'edit';
		this.editable = false;
		this.pageTitle = this.pageTitleGenerate();
		if (this.service.checkExit) this.router.navigate(['product']);
		else this.router.navigate(['product', this.service.data.id]);
		this.apiUrl = '/product/' + this.service.data.id + '/';
		this.reloadHistory();
		this.infobox.success('Zapisano');

		this.dialog.open(ProductRedirectDialogComponent, {
			data: { productId: this.service.data.id },
			disableClose: true,
		});
	}
}
